export default {
  name: 'machineChecklistMember',
  miniSave: true,
  uploadFunction: ({ requestFunction, data, saveId }) => {
    return requestFunction.methodRequest(
      `/register/machine/checklist/${data.machineid}/operator`,
      'POST',
      data
    )
  },
}
